/**
 * GA4 / Google Ads 埋点统一入口。
 *
 * 用法:
 *   import { track, trackPurchase } from '@/utils/track'
 *   track('begin_checkout', { value: 99, currency: 'USD' })
 *   trackPurchase({ orderId, value, currency, items: [...] })
 *
 * 设计:
 * - gtag 不存在时安静失败（开发环境 / 未加载 GA 时不报错）
 * - 所有现场只调 track(...)，不直接 window.gtag(...)，方便以后切 GTM / mixpanel
 * - GA4 标准 ecommerce 事件名沿用官方 schema:
 *   https://developers.google.com/analytics/devguides/collection/ga4/ecommerce
 *
 * Google Ads 转化（路径 B）:
 * - 在 public/index.html 设置 window.GOOGLE_ADS_CONVERSION_SEND_TO =
 *   'AW-XXXXX/labelXXX' 即可启用；trackPurchase 会自动转一次到 Ads
 * - 留空时只发 GA4 purchase（路径 A：通过 GA4 link 把 purchase 导入 Ads
 *   作为 conversion，无需此处发独立 conversion event）
 */

function _gtag () {
  if (typeof window === 'undefined') return null
  return typeof window.gtag === 'function' ? window.gtag : null
}

export function track (eventName, params) {
  const g = _gtag()
  if (!g || !eventName) return
  try {
    g('event', eventName, params || {})
  } catch (e) {
    // GA 失败不应影响业务流程
  }
}

export function trackPurchase ({ orderId, value, currency, items, coupon }) {
  if (!orderId) return
  const payload = {
    transaction_id: String(orderId),
    affiliation: 'iPastBook',
    value: Number(value || 0),
    currency: currency || 'USD',
    items: items || []
  }
  if (coupon) payload.coupon = coupon
  track('purchase', payload)

  // 路径 B：如果配了独立 Google Ads conversion ID，再发一次 conversion
  const sendTo = (typeof window !== 'undefined') && window.GOOGLE_ADS_CONVERSION_SEND_TO
  if (sendTo) {
    track('conversion', {
      send_to: sendTo,
      value: payload.value,
      currency: payload.currency,
      transaction_id: payload.transaction_id
    })
  }
}
